module.exports = __webpack_public_path__ + "media/MarblePuzzle_Mobile.31f79a3f.mp4";